import React, { useState, useEffect, useContext } from "react"
import { Link, Redirect } from "react-router-dom"
import ButtonsGrid from "../../../components/ButtonsGrid"
import Table from "../../../components/Table"
import { OutorgaContext } from "../../../contexts/Outorga"
import GenericModal from "../../../components/GenericModal"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

const Grid = () => {
    const context = useContext(OutorgaContext)
    const history = useHistory();

    const [redirectToEdit, setRedirectToEdit] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selected, setSelected] = useState([])
    const [tableRef, setTableRef] = useState(null)

    const {
        grantList,
        isLoadingGrantList,
        count,
        next,
        previous,
        getGrantList,
        removeGrant
    } = context

    useEffect(() => {
        getGrantList()
    }, [])

    const canEdit = selected.length === 1
    const canDelete = selected.length > 0

    const editar = () => {
        if (!selected.length) return

        setRedirectToEdit({ pathname: `outorga/${selected[0]}/editar` })
    }

    const deletar = () => {
        if (!selected.length) return

        removeGrant(selected)
        tableRef?.unselect?.()
        setSelected([])
        handleDeleteModal()
    }

    const handleDeleteModal = () => {
        setShowDeleteModal(prev => !prev)
    }

    const goToMapItem = (itemId) => {
        history.push("/ambiental/dashboard", { focusItemId: itemId });
    };

    const convertDate = (date) =>
        new Date(Date.parse(date)).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric"
        })

    if (redirectToEdit) {
        return <Redirect to={redirectToEdit} />
    }

    const columns = [
        { Header: "Descrição", Accessor: "nome" },
        {
            Header: "Data de Início",
            Accessor: "data_inicio",
            sortable: true,
            Cell: (original) => (
                <span>{convertDate(original.data_inicio)}</span>
            )
        },
        {
            Header: "Data de Vencimento",
            Accessor: "data_vencimento",
            sortable: true,
            Cell: (original) => (
                <span>{convertDate(original.data_vencimento)}</span>
            )
        },
        { Header: "Id de Referência", Accessor: "id_referencia" },
        {
            Center: true,
            Header: "Localizar na Dashboard",
            title: "Localizar na Dashboard",
            Cell: (original) => {
                return (
                    <span
                        className='acessar-button'
                        onClick={() => goToMapItem(original.id)}
                    >
                        <i className="fa fa-map-marked fa-30px" style={{ cursor: "pointer" }} />
                    </span>
                )
            }
        }
    ]

    const handleTableUpdate = (tableState) => {
        setSelected(tableState?.state?.selected || [])
        setTableRef(tableState)
    }

    return (
        <div>
            <div className="hdv-default-header mx-3">
                <span className="screen-menu-desc">
                    <h4>Cadastro de Outorgas</h4>
                    <div className="gray-background">
                        <i className="fa fa-file-contract fa-2x"></i>
                    </div>
                </span>
            </div>

            <div className="hdv-btn-group">
                <ButtonsGrid
                    route="/ambiental/outorga"
                    buttons={[
                        {
                            method: "post",
                            button: (
                                <Link to={"outorga/novo"}>
                                    <button className="hdv-btn-forms hdv-btn-green">
                                        Novo
                                    </button>
                                </Link>
                            )
                        },
                        {
                            method: "patch",
                            button: (
                                <button
                                    onClick={editar}
                                    disabled={!canEdit}
                                    className="hdv-btn-forms hdv-btn-yellow"
                                >
                                    Editar
                                </button>
                            )
                        },
                        {
                            method: "delete",
                            button: (
                                <button
                                    onClick={handleDeleteModal}
                                    disabled={!canDelete}
                                    className="hdv-btn-forms hdv-btn-red"
                                >
                                    Excluir
                                </button>
                            )
                        }
                    ]}
                />
            </div>

            <Table
                key={"grant-table"}
                checkbox
                data={grantList}
                loading={isLoadingGrantList}
                count={count}
                next={next}
                previous={previous}
                columns={columns}
                onFetchData={getGrantList}
                onUpdate={handleTableUpdate}
            />

            <GenericModal
                isOpen={showDeleteModal}
                title="Deletar Outorga"
                description="Tem certeza que deseja deletar essa outorga?"
                onConfirm={deletar}
                onClose={handleDeleteModal}
                isDelete={true}
            />
        </div>
    )
}

export default Grid